<template>

  <div id="lxwm"
    style="background-color: #252525;color: #FFFFFF;padding-top: 24px;padding-bottom: 20px;margin-top: 20px;">
    <div class="row  text-left">
      <div class="col-md-2 col-md-offset-1 col-xs-12">
        <ul class="list-unstyled">
          <li>
            <h4>联系我们</h4>
          </li>

          <li style="margin-top: 20px;">
            <h5>郑州市嵩山路与南彩路交叉口锦和广场1号楼3号门5楼</h5>
          </li>
          <li>
            <h5>联系电话:</h5>
          </li>
          <li>
            <h5>苗总(18703679018)</h5>
          </li>
          <li>
            <h5>办公室(0371-86677877)</h5>
          </li>

        </ul>
      </div>
      <div class="col-md-6 visible-lg-block visible-md-block">
        <h4>分公司</h4>
        <div class="row">
          <div class="col-md-4">
            <ul class="list-unstyled">
              <li>
                <h5>郑州一分公司</h5>
              </li>
              <li>
                <h5>郑州二分公司</h5>
              </li>
              <li>
                <h5>郑州三分公司</h5>
              </li>
              <li>
                <h5>郑州五分公司</h5>
              </li>
              <li>
                <h5>郑州六分公司</h5>
              </li>
              <li>
                <h5>郑州七分公司</h5>
              </li>
              <li>
                <h5>郑州八分公司</h5>
              </li>
              <li>
                <h5>郑州九分公司</h5>
              </li>
              <li>
                <h5>郑州十分公司</h5>
              </li>
              <li>
                <h5>新密分公司</h5>
              </li>
            </ul>

          </div>
          <div class="col-md-4">
            <ul class="list-unstyled">
              <li>
                <h5>新郑分公司</h5>
              </li>
              <li>
                <h5>开封分公司</h5>
              </li>
              <li>
                <h5>商丘分公司</h5>
              </li>
              <li>
                <h5>三门峡分公司</h5>
              </li>
              <li>
                <h5>许昌分公司</h5>
              </li>
              <li>
                <h5>平顶山分公司</h5>
              </li>
              <li>
                <h5>驻马店分公司</h5>
              </li>
              <li>
                <h5>南阳分公司</h5>
              </li>
              <li>
                <h5>信阳分公司</h5>
              </li>
              <li>
                <h5>新乡分公司</h5>
              </li>
            </ul>

          </div>








          <div class="col-md-4">
            <ul class="list-unstyled">
              <li>
                <h5>濮阳分公司</h5>
              </li>
              <li>
                <h5>林州振兴分公司</h5>
              </li>
              <li>
                <h5>安阳分公司</h5>
              </li>
              <li>
                <h5>鹤壁分公司</h5>
              </li>
              <li>
                <h5>漯河分公司</h5>
              </li>
              <li>
                <h5>广州分公司</h5>
              </li>
            </ul>

          </div>
        </div>
      </div>
      <div class="col-md-2 ">
        <ul class="list-unstyled ">
          <li>
            <h4>官方账号</h4>
          </li>
          <li>
            <img  class="img-responsive" src="../../assets/weixin.jpg"  style="margin-top: 15px;"/>
          </li>
        </ul>
      </div>
    </div>

    <div class="text-center">
      <h5>copyright2005-2022河南威盾保安服务有限公司 | All Rights Reserved <a href="https://beian.miit.gov.cn" target="_blank"
          style="color: #FFFFFF;">豫ICP备11010616号</a></h5>
      <h5>技术支持：河南威盾保安服务有限公司技术部</h5>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Base',
    data() {
      return {

      }
    },
    methods: {

    }
  }
</script>

<style>
  .row {
    margin-left: 0px;
    margin-right: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/base.vue